import React from "react";
import style from "./workListCommon.module.scss";
import { VerticalTabWorkList } from "../../secondary/VerticalTabWorkList";
import { useWorkListTabs } from "./hooks/useWorkListTabs";
import { WorklistScreen } from "./worklistScreen";
import { WORKLIST_CONFIG } from "./worklistConfig";

export function NewWounds({ facilityNumber }) {
  const { dispatch, defaultVerTab, onSelectVerTab, poaCount, nonpoaCount } = useWorkListTabs(facilityNumber, "newWoundsValues");

  const tabList = [
    {
      name: `POA ${poaCount}`,
      key: "poa",
      content: <WorklistScreen facilityNumber={facilityNumber} config={WORKLIST_CONFIG.newWoundsPOA} />,
      bottomName: "Pending Assessment",
      bgcolor: style.new_wound_bgcolor,
    },
    {
      name: `Non-POA ${nonpoaCount}`,
      key: "nonPoa",
      content: <WorklistScreen facilityNumber={facilityNumber} config={WORKLIST_CONFIG.newWoundsNONPOA} />,
      bottomName: "Pending Assessment",
      bgcolor: style.new_wound_bgcolor,
    },
  ];
  return (
    <VerticalTabWorkList onSelectInt={onSelectVerTab} defaultIndex={defaultVerTab <= 1 ? defaultVerTab : 0} tabList={tabList} dispatch={dispatch} />
  );
}
